import React from "react";
import { Heart, Sparkles, ExternalLink } from "lucide-react";
import { SITE_URL, SITE_LABEL } from "./Header";

export const Footer = ({ lang }) => (
  <footer className="relative z-10 border-t border-primary/20 bg-black/70 backdrop-blur-xl">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-9 flex flex-col sm:flex-row items-center justify-between gap-6">
      {/* Brand / own URL */}
      <div className="text-center sm:text-left">
        <div className="flex items-center justify-center sm:justify-start gap-2 mb-1.5">
          <Heart className="w-4 h-4 text-primary" fill="currentColor" />
          <span className="font-serif-display text-lg gold-text">Seelenpartner-Tarot</span>
        </div>
        <a
          href={SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-site-url"
          className="inline-flex items-center gap-1.5 text-sm text-primary/90 hover:text-primary transition-colors"
        >
          {SITE_LABEL}
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>

      {/* Emergent promo */}
      <a
        href="https://app.emergent.sh"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="emergent-ad-link"
        className="group flex items-center gap-3 rounded-full border border-primary/30 bg-gradient-to-r from-[#f7c873]/10 to-[#ff8fa3]/10 hover:from-[#f7c873]/20 hover:to-[#ff8fa3]/20 px-5 py-3 transition-colors"
      >
        <Sparkles className="w-5 h-5 text-primary" />
        <div className="text-left leading-tight">
          <p className="text-[13px] text-muted-foreground">
            {lang === "de" ? "Erstellt mit" : "Built with"}
          </p>
          <p className="text-sm font-semibold gold-text">Emergent — emergent.sh</p>
        </div>
        <ExternalLink className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-colors" />
      </a>
    </div>

    <div className="border-t border-primary/10">
      <p className="max-w-6xl mx-auto px-5 sm:px-8 py-4 text-center text-xs text-muted-foreground/70">
        {lang === "de"
          ? "✨ Baue deine eigene KI-App mit Emergent – schnell, ohne Code-Stress. © "
          : "✨ Build your own AI app with Emergent – fast, without the code hassle. © "}
        {new Date().getFullYear()} {SITE_LABEL}
      </p>
    </div>
  </footer>
);
